import type { SubmissionStatus } from "@edge/shared";

/** Display labels for the 10 statuses — single source of truth for the SPA. */
export const STATUS_LABELS: Record<SubmissionStatus, string> = {
  pitched: "Pitched",
  reviewing: "Reviewing",
  need_info: "Items Requested",
  terms: "Terms Out",
  negotiating: "Negotiating",
  backup: "Backup",
  declined: "Declined",
  withdrawn: "Withdrawn",
  ghosted: "Ghosted",
  funded: "Funded",
};

/** Render-time uppercase variant used by pill components. */
export const STATUS_PILL_LABELS: Record<SubmissionStatus, string> = {
  pitched: "PITCHED",
  reviewing: "REVIEWING",
  need_info: "ITEMS REQUESTED",
  terms: "TERMS OUT",
  negotiating: "NEGOTIATING",
  backup: "BACKUP",
  declined: "DECLINED",
  withdrawn: "WITHDRAWN",
  ghosted: "GHOSTED",
  funded: "FUNDED",
};

export const ALL_STATUSES: readonly SubmissionStatus[] = [
  "pitched",
  "reviewing",
  "need_info",
  "terms",
  "negotiating",
  "backup",
  "declined",
  "withdrawn",
  "ghosted",
  "funded",
];

/**
 * Loose state-machine — these are *suggested* transitions surfaced at the
 * top of the picker. The dialog also exposes every other status as a
 * manual override; the API enforces nothing. Terminal statuses get empty
 * suggested lists.
 */
export const VALID_TRANSITIONS: Record<SubmissionStatus, SubmissionStatus[]> = {
  pitched:     ["reviewing", "need_info", "declined", "ghosted", "withdrawn"],
  reviewing:   ["need_info", "terms", "declined", "ghosted", "withdrawn"],
  need_info:   ["terms", "declined", "ghosted", "withdrawn"],
  terms:       ["negotiating", "funded", "backup", "declined", "withdrawn"],
  negotiating: ["terms", "funded", "backup", "declined", "withdrawn"],
  backup:      ["terms", "negotiating", "funded", "declined", "withdrawn"],
  declined:    [],
  withdrawn:   [],
  ghosted:     [],
  funded:      [],
};

/**
 * Does this status transition require a captured reason?
 * - declined → decline_reason required
 * - backup   → backup_reason required
 */
export function requiresReason(
  status: SubmissionStatus,
): "decline" | "backup" | null {
  if (status === "declined") return "decline";
  if (status === "backup") return "backup";
  return null;
}
